import React from "react";
import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { Select } from "../../components/Select";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";

export class OrderCancellationDrawer extends React.Component {

    state = {
        loading: false,
        savingOptions: false,
        cancellationCode: null,
        reason: "",
    }

    async setAsyncState(data) {
        return new Promise((resolve) => this.setState(data, resolve));
    }

    async onSave() {
        try {
            const { order, onClose } = this.props;
            const { reason, cancellationCode } = this.state;

            await this.setAsyncState({ savingOptions: true });

            try {
                const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
                const response = await IntegrationsAPI.cancelOrder(order.id, reason, cancellationCode, selectedEnvironment);
                if (response.getErrors([]).length === 0) {
                    onClose();
                } else {
                    alert({ text: `Não foi possível solicitar o cancelamento: ${response.getErrors()[0]}` });
                }
            } catch (err) {
                alert({ text: `Não foi possível solicitar o cancelamento` });
            }

            await this.setAsyncState({ savingOptions: false });
        } catch (e) {
            await this.setAsyncState({ savingOptions: false });
        }
    }

    getCancellationOptions () {
        const { cancellationCodes } = this.props;
        const { cancellationCode } = this.state;
        
        return cancellationCodes.map((item) => ({
            label: item.description, 
            value: item.cancelCodeId, 
            selected: item.cancelCodeId == cancellationCode
        }));
    }

    render() {
        const { visible, onClose, order } = this.props;
        const { savingOptions, loading, reason, cancellationCode } = this.state;

        const invalidForm = !reason || !cancellationCode;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title={`Pedido #${order.displayId}`}
                footer={
                    <Button
                        design="primary"
                        className="w-100"
                        onClick={this.onSave.bind(this)}
                        loading={savingOptions}
                        disabled={loading || savingOptions || invalidForm}
                    >
                        Solicitar cancelamento
                    </Button>
                }
            >

                {loading ? (
                    <div className="d-flex justify-center align-center h-100">
                        <Loading fullScreen />
                    </div>
                ) : (
                    <>
                        <Select
                            design="two"
                            label="Tipo de cancelamento"
                            onChange={(e) => this.setState({ cancellationCode: e.target.value })}
                            className="mb-15"
                            value={cancellationCode}
                            options={[
                                { label: "Selecione um tipo", value: "" },
                                ...this.getCancellationOptions()
                            ]}
                        />
                        <Input
                            design="two"
                            label="Motivo"
                            value={reason}
                            onChange={(e) => this.setState({ reason: e.target.value })}
                        />
                    </>
                )}
            </Drawer>
        )
    }
}
